import React from 'react'

export default function Title() {
  return (
    <div className=' justify-center items-center hidden lg:flex lg:mt-14 xl:mt-16'>
      <h1 className='text-[#2E3D62] text-[30px] md:text-[40px] font-bold'> Why <span className='text-[#CB0B0B]'> HNL-TECH?</span></h1>
    </div>
  )
}
